(() => {
  const drawer = document.getElementById('sidebar-mobile-nav');
  if (!drawer || drawer.dataset.bsMenuReady) return;
  drawer.dataset.bsMenuReady = 'true';
  const triggers = [...document.querySelectorAll('[data-target="#sidebar-mobile-nav"]')];
  const close = drawer.querySelector('.bt-sidebar__close');
  let previousFocus = null;
  let wasOpen = false;
  let nextId = 0;
  const isOpen = () => document.body.classList.contains('open-sidebar-canvas--sidebar-mobile-nav');
  const focusable = () => [...drawer.querySelectorAll('a[href],button,input,select,textarea,summary,[tabindex="0"]')]
    .filter(el => !el.disabled && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden');
  const enhance = () => {
    drawer.querySelectorAll('.mobile-nav__arrow').forEach(arrow => {
      const item = arrow.closest('.mobile-nav__item');
      const panel = item && item.querySelector(':scope > .mobile-nav__children');
      if (!panel) return;
      if (!panel.id) panel.id = 'bs-menu-panel-' + (++nextId);
      const expanded = item.classList.contains('open');
      arrow.setAttribute('role', 'button');
      arrow.setAttribute('aria-controls', panel.id);
      arrow.setAttribute('aria-expanded', String(expanded));
      panel.setAttribute('aria-hidden', String(!expanded));
      panel.inert = !expanded;
      const link = arrow.parentElement.querySelector('a:not(.mobile-nav__arrow)');
      if (link) {
        const label = (link.getAttribute('title') || link.textContent).trim();
        arrow.setAttribute('aria-label', (drawer.dataset.submenuLabel || '__TITLE__').replace('__TITLE__', label));
      }
    });
    drawer.querySelectorAll('.mobile-nav__children__block').forEach(block => {
      if (block.dataset.bsGrouped) return;
      const heading = block.querySelector('.mobile-nav__level2');
      if (!heading || !heading.textContent.trim()) return;
      block.dataset.bsGrouped = 'true';
      const group = document.createElement('details');
      group.className = 'bs-menu-group';
      const summary = document.createElement('summary');
      summary.textContent = heading.textContent.trim();
      const content = document.createElement('div');
      content.className = 'bs-menu-group__body';
      while (block.firstChild) content.appendChild(block.firstChild);
      const seen = new Set();
      content.querySelectorAll('a[href]').forEach(link => {
        const key = link.href + '|' + link.textContent.trim();
        const item = link.closest('li');
        if (seen.has(key) && item && item.querySelectorAll('a').length === 1) item.remove();
        else seen.add(key);
      });
      group.append(summary, content);
      block.appendChild(group);
    });
  };
  const sync = () => {
    const open = isOpen();
    drawer.inert = !open;
    drawer.setAttribute('aria-hidden', String(!open));
    if (open) drawer.setAttribute('aria-modal', 'true');
    else drawer.removeAttribute('aria-modal');
    triggers.forEach(trigger => trigger.setAttribute('aria-expanded', String(open)));
    if (open && !wasOpen) {
      previousFocus = document.activeElement;
      (close || drawer).focus({ preventScroll: true });
    } else if (!open && wasOpen && previousFocus && previousFocus.isConnected) {
      previousFocus.focus({ preventScroll: true });
    }
    wasOpen = open;
  };
  if (close) close.setAttribute('role', 'button');
  drawer.addEventListener('keydown', event => {
    if (event.key === ' ' && event.target.matches('.mobile-nav__arrow,.bt-sidebar__close')) {
      event.preventDefault();
      event.target.click();
    }
  });
  document.addEventListener('keydown', event => {
    if (!isOpen()) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      if (close) close.click();
    } else if (event.key === 'Tab') {
      const items = focusable();
      const first = items[0] || drawer;
      const last = items[items.length - 1] || drawer;
      if (event.shiftKey && (document.activeElement === first || !drawer.contains(document.activeElement))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (document.activeElement === last || !drawer.contains(document.activeElement))) {
        event.preventDefault();
        first.focus();
      }
    }
  });
  new MutationObserver(sync).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  new MutationObserver(enhance).observe(drawer, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  enhance();
  sync();
})();
